<template>
  <custom-btn-icon
    @click.stop="handleClick"
    :btn-text="generateMessage('requests.actions.pause')"
    color="primary"
    icon="mdi-pause"
  />
</template>

<script>
import { generateMessage } from '@/utils/i18n';
import { mapActions } from 'vuex';
import CustomBtnIcon from '@/components/displays/CustomBtnIcon';

export default {
  name: 'PauseBtnDialog',
  components: {
    CustomBtnIcon,
  },
  props: {
    requestId: {
      type: Number,
      required: true,
    },
  },
  methods: {
    generateMessage,
    ...mapActions('modal', ['showModal']),
    handleClick() {
      this.showModal({
        componentName: 'PauseDialog',
        componentProps: {
          requestId: this.requestId,
          entity_nav_full_id: this.entity_nav_full_id,
        },
        dialogProps: {
          width: '600px',
        },
      });
    },
  },
};
</script>
